import React from "react";
import { Button, Tooltip } from "antd";
import { EditOutlined } from "@ant-design/icons";

const EditButton = ({ onClick }) => (
  <Tooltip title="Edit">
    <Button icon={<EditOutlined />} onClick={onClick} />
  </Tooltip>
);

export default EditButton;
